import PropTypes from 'prop-types'
import DevToolsSidebar from './DevToolsSidebar'
import { PageContainer, LayoutCard, ContentArea } from './styled-components'

const DevToolsLayout = ({ children }) => {
  return (
    <PageContainer>
      <LayoutCard>
        <DevToolsSidebar />
        <ContentArea>{children}</ContentArea>
      </LayoutCard>
    </PageContainer>
  )
}

DevToolsLayout.propTypes = { children: PropTypes.node }
export default DevToolsLayout
